import React, { useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import Collapse from 'react-native-collapsible';

import { VFText, Icon, IconTypes } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import PropTypes from 'prop-types';

import { getThemeImages } from '../../../Themes';
import BillingTestKeys from '../../../Utils/BillingTestKeys.js';
import VfView from '../../VfView';

import styles from './ExpansionPanelItem.Styles';

function ExpansionPanelItem(props) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { theme } = props;
  const themeImages = getThemeImages(theme.name);

  const onAdditionalInfoIconPress = () => {
    props.toggleModal(
      props.additionalInfo.modalHeadline,
      props.additionalInfo.additionalInfoTitle,
      props.additionalInfo.additionalInfoContent,
    );
  };

  const renderAdditionalInfoIcon = () => {
    return (
      <TouchableOpacity
        onPress={onAdditionalInfoIconPress}
        activeOpacity={1}
        hitSlop={{
          top: 10,
          left: 10,
          bottom: 10,
          right: 10,
        }}
        testID={BillingTestKeys.additionalInfoIconTO}
      >
        <View
          style={styles.additionalInfoContainer}
          testID={BillingTestKeys.additionalInfoIconView}
        >
          <Icon
            source={themeImages.icInfoRed}
            type={IconTypes.image}
            size={20}
            style={styles.icon}
            testID={BillingTestKeys.additionalInfoIconIcon}
          />
        </View>
      </TouchableOpacity>
    );
  };

  return (
    <>
      <TouchableOpacity
        activeOpacity={0.7}
        onPress={() => setIsCollapsed(isCollapsedState => !isCollapsedState)}
        disabled={props.items.length === 0}
        testID={BillingTestKeys.expansionPanelItemTO}
      >
        <VfView
          row
          style={styles.root}
          justify="space-between"
          testID={BillingTestKeys.expansionPanelItemView}
        >
          <VfView style={[props.omitLongText && styles.longTextTitleView, { flex: 1 }]}>
            <VfView direction="row" testID={BillingTestKeys.expansionPanelItemBeforeTitleLabelView}>
              {props.beforeTitleLabel && (
                <VFText
                  i18nKey={`${props.beforeTitleLabel}`}
                  style={styles.beforeTitleLabel(theme)}
                  testKey={BillingTestKeys.expansionPanelItemBeforeTitleLabelText}
                />
              )}
              {props.beforeTitleLabel && <VFText i18nKey={': '} />}
              <VFText
                i18nKey={`${props.title}`}
                style={[styles.titleText(theme), props.itemTitleStyle]}
                {...(props.omitLongText && { numberOfLines: 1 })}
                testKey={BillingTestKeys.expansionPanelItemTitleText}
              />
              {props.additionalInfo &&
                props.additionalInfo.isShownOutside &&
                renderAdditionalInfoIcon()}
              {!props.isCollapsed &&
                props.additionalInfo &&
                !props.additionalInfo.isShownOutside &&
                renderAdditionalInfoIcon()}
            </VfView>
            {props.subtitle && (
              <VFText
                style={styles.subtitle(theme)}
                i18nKey={`${props.subtitle}`}
                testKey={BillingTestKeys.expansionPanelItemSubtitleText}
              />
            )}
          </VfView>
          {props.price && (
            <VFText
              i18nKey={`${props.price}`}
              style={[styles.price(theme), props.omitLongText && styles.longPrice]}
              testKey={BillingTestKeys.expansionPanelItemPriceText}
            />
          )}
        </VfView>
      </TouchableOpacity>
      <Collapse collapsed={isCollapsed}>
        <VfView
          style={
            props.removeBorderBottom
              ? styles.collapsedItemContainerTop
              : styles.collapsedItemContainerTopBottom
          }
          testID={BillingTestKeys.expansionPanelItemListView}
        >
          {props?.items?.map((itemTitle, i) => (
            <VfView
              style={styles.collapsedItem}
              key={i}
              testID={BillingTestKeys.expansionPanelItemCollapsedListView}
            >
              <VFText
                style={styles.itemTitle(theme)}
                i18nKey={`${itemTitle}`}
                testKey={BillingTestKeys.expansionPanelItemCollapsedListTitleText}
              />
            </VfView>
          ))}
        </VfView>
      </Collapse>
    </>
  );
}

ExpansionPanelItem.defaultProps = {
  items: [],
  theme: LightThemeColors,
  omitLongText: false,
};

ExpansionPanelItem.propTypes = {
  title: PropTypes.string,
  itemTitleStyle: PropTypes.object,
  beforeTitleLabel: PropTypes.string,
  subtitle: PropTypes.string,
  price: PropTypes.string,
  items: PropTypes.array,
  removeBorderBottom: PropTypes.bool,
  theme: PropTypes.object,
  additionalInfo: PropTypes.object,
  isCollapsed: PropTypes.bool,
  toggleModal: PropTypes.func,
  omitLongText: PropTypes.bool,
};

export default withTheme(ExpansionPanelItem);
